import axios from "axios";

/* -------------------------------------------------------------------------------- *\
|                               findapiserverurl
\* -------------------------------------------------------------------------------- */
export const findapiserverurl = (): string =>
{
	const origin: string = window.location.origin;
	return origin.replace('3000', '5040');
}
/* -------------------------------------------------------------------------------- *\
|                               getlast
\* -------------------------------------------------------------------------------- */
export const getlast = async () : Promise<any[]> =>
{
	return Promise.resolve()
		.then(() => axios.get(findapiserverurl() + `/api/getlast`))
		.then(response => 
		{
			var datas = response.data as any[];
			return datas;
		});
}
